import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import {
  trigger,
  state,
  style,
  animate,
  transition,
} from '@angular/animations';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { NzModalService } from 'ng-zorro-antd/modal';
import { environment } from 'src/environments/environment';
import { BuildDetailsComponent } from '../../shared-resources/components/build-details/build-details.component';
import { BuildInfoService } from '../../shared-resources/services/build-info.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.less'],

  animations: [
    trigger('changeDivSize', [
      state(
        'initial',
        style({
          position: 'fixed',
          right: '-450px',
          bottom: '50px',
          width: '450px',
          opacity: 0,
          height: '25px',
        })
      ),
      state(
        'final',
        style({
          opacity: 1,
          right: '82px',
          height: '25px',
          width: '450px',
          position: 'fixed',
          bottom: '50px',
        })
      ),
      transition('initial=>final', animate('500ms')),
      transition('final=>initial', animate('500ms')),
    ]),
  ],
})
export class FooterComponent implements OnInit {
  @ViewChild('toggleButton') toggleButton: ElementRef;
  @ViewChild('menu') menu: ElementRef;
  public appName: string;
  public appVersion: string;
  public complaintisVisible = false;
  public suggestionisVisible = false;
  public feedbackisVisible = false;
  public enquiryisVisible = false;
  public date = new Date();
  selectedDb = sessionStorage.getItem('X-Tenant-ID') || 'MAIN';
  dbOptions = ['MAIN', 'TDR'];

  onDbChange(value: string): void {
    sessionStorage.setItem('X-Tenant-ID', value);
    window.location.reload();
  }
  private buildData: any[] = [];
  constructor(private router: Router, private translate: TranslateService, private http: HttpClient, private modal: NzModalService, private buildInfoService: BuildInfoService) {}
  isMenuOpen = false;
  currentState = 'initial';
  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }
  changeState(): void {
    this.currentState = this.currentState === 'initial' ? 'final' : 'initial';
  }
  complaint(): void {
    this.complaintisVisible = true;
  }
  suggestion(): void {
    this.suggestionisVisible = true;
  }
  feedback(): void {
    this.feedbackisVisible = true;
  }
  businessEnquiry(): void {
    this.enquiryisVisible = true;
  }
  handleOk(): void {
    console.log('Button ok clicked!');
    this.complaintisVisible = false;
    this.suggestionisVisible = false;
    this.feedbackisVisible = false;
    this.enquiryisVisible = false;
  }

  handleCancel(): void {
    console.log('Button cancel clicked!');
    this.complaintisVisible = false;
    this.suggestionisVisible = false;
    this.feedbackisVisible = false;
    this.enquiryisVisible = false;
  }
  Complaint(): void {
    this.router.navigateByUrl('/app/layout/complaint');
  }
  onAppVersionClick(): void {
    const modalRef = this.modal.create({
      nzTitle: 'Build Details',
      nzContent: BuildDetailsComponent,
      nzFooter: null,
      nzWidth: 700
    });
    
    if (modalRef.componentInstance) {
      modalRef.componentInstance.buildInfo = this.buildData;
      modalRef.componentInstance.groupedBuildInfo = this.groupByServiceName(this.buildData);
      modalRef.componentInstance.loading = false;
    }
  }

  ngOnInit(): void {
    this.appName = environment.appTitle;
    this.loadAppVersion();
  }

  private loadAppVersion(): void {
    this.buildInfoService.getBuildInfo().subscribe({
      next: (data: any[]) => {
        this.buildData = data;
        const uiBaseAdminService = data.find(item => item.serviceName === 'ui-base-admin');
        // this.appVersion = uiBaseAdminService ? uiBaseAdminService.buildNumber : environment.appVersion;
        this.appVersion = environment.appVersion;
      },
      error: () => {
        this.appVersion = environment.appVersion;
      }
    });
  }

  private groupByServiceName(data: any[]) {
    return data.reduce((acc, item) => {
      const key = item.serviceName;
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(item);
      return acc;
    }, {} as { [key: string]: any[] });
  }
}
